module.exports = __webpack_public_path__ + "img/qinghuaUniversityLogo.89ce07b1.png";